import styled from 'styled-components';
import { getSpace, px2rem } from '../../../../stylesheets/tools';

const StyledEducationSteps = styled.section`
  padding: ${getSpace('xl')} 0;

  .steps__header {
    margin-bottom: ${getSpace('l')};

    .steps__header-headline {
      margin-bottom: ${getSpace('xxs')};
    }
  }
  .steps__grid {
    display: flex;
    flex-direction: column;
    gap: ${px2rem('60px')};
  }
`;

export default StyledEducationSteps;
